import { connect } from 'react-redux'
import { forgottenPassword } from './reducer'

const mapStateToProps = (state) => {
    return {
        isAuth: state?.services?.auth?.isAuthorized,
    }
}

const hocChangeForgottenPassword = (InnerComponent) => connect(mapStateToProps, { forgottenPassword })(InnerComponent)

export default hocChangeForgottenPassword
